<button mat-menu-item
    [ngClass]="{ 'cm-main-menu__item--active': currentPage === NAVIGATION_VIEWS.HOME }"
    routerLink="/">
    <span>{{'Home' | translate }}</span>
</button>
<button mat-menu-item
    [ngClass]="{ 'cm-main-menu__item--active': currentPage === NAVIGATION_VIEWS.GETTING_STARTED }"
    routerLink="getting-started">
    <span>{{'Getting Started' | translate }}</span>
</button>
<button mat-menu-item
    [ngClass]="{ 'cm-main-menu__item--active': currentPage === NAVIGATION_VIEWS.ABOUT_US }"
    routerLink="about-us">
    {{'About Us' | translate }}
</button>
<button mat-menu-item
    [ngClass]="{ 'cm-main-menu__item--active': currentPage === NAVIGATION_VIEWS.ET_CALCULATOR }"
    routerLink="et-calculator">
    {{'Seasonal ET Calculator' | translate }}
</button>
<button mat-menu-item
    [ngClass]="{ 'cm-main-menu__item--active': currentPage === NAVIGATION_VIEWS.IR_CALCULATOR }"
    routerLink="ir-calculator">
    {{'Irrigation Calculator' | translate }}
</button>
<button mat-menu-item
    [ngClass]="{ 'cm-main-menu__item--active': currentPage === NAVIGATION_VIEWS.API }"
    routerLink="web-api">
    {{'API' | translate }}
</button>
<mat-divider></mat-divider>
<button mat-menu-item
	[ngClass]="{ 'cm-main-menu__item--active': currentPage === NAVIGATION_VIEWS.LOGIN }"
    routerLink="login">
    {{'Log In' | translate }}
</button>
<button mat-menu-item
    [ngClass]="{ 'cm-main-menu__item--active': currentPage === NAVIGATION_VIEWS.REGISTER }"
    routerLink="register">
    {{'Get Started for Free' | translate }}
</button>